import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { designMatchesLoad } from 'portal/store/designMatches/actions'
import { DesignMatchRow } from 'portal/store/designMatches/types'

const EMPTY_ARRAY: DesignMatchRow[] = []
const EMPTY_PRODUCT_GROUP_NAMES: string[] = []
const EMPTY_SUPPLIER_NAMES: string[] = []

export const useDesignMatchesLoader = (
  productGroupNames: string[] = EMPTY_PRODUCT_GROUP_NAMES,
  supplierNames: string[] = EMPTY_SUPPLIER_NAMES
) => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()
  const [page, setPage] = useState(1)

  const { loading, error, items, totalCount, hasNextPage } = useSelector(
    (state: any) => state.designMatches
  )

  useEffect(() => {
    if (!accountId || !projectId || productGroupNames.length === 0) {
      return
    }
    setPage(1)
    dispatch(
      designMatchesLoad(
        accountId,
        projectId,
        1,
        EMPTY_ARRAY,
        productGroupNames,
        supplierNames
      )
    )
  }, [accountId, projectId, dispatch, productGroupNames, supplierNames])

  const loadNextPage = useCallback(() => {
    if (
      !accountId ||
      !projectId ||
      !hasNextPage ||
      loading ||
      productGroupNames.length === 0
    ) {
      return
    }
    const nextPage = page + 1
    setPage(nextPage)
    dispatch(
      designMatchesLoad(
        accountId,
        projectId,
        nextPage,
        items,
        productGroupNames,
        supplierNames
      )
    )
  }, [
    accountId,
    projectId,
    dispatch,
    hasNextPage,
    loading,
    page,
    items,
    productGroupNames,
    supplierNames
  ])

  return {
    loading,
    error,
    items,
    totalCount,
    hasNextPage,
    loadNextPage
  }
}
